import axios from "axios";
const DESCO_API_BASE = import.meta.env.VITE_DESCO_API_BASE;
const ESTATY_API_BASE = import.meta.env.VITE_ESTATY_API_BASE;
const ESTATY_APP_KEY = import.meta.env.VITE_ESTATY_APP_KEY;

// Create axios instances
const descoApi = axios.create({
  baseURL: DESCO_API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

const estatyApi = axios.create({
  baseURL: ESTATY_API_BASE,
  headers: {
    "App-key": ESTATY_APP_KEY,
    "Content-Type": "application/json",
  },
});

// API Services
export const apiService = {
  // Banner APIs
  getBanners: () => descoApi.get("/banner/index"),

  // Developer APIs
  getDevelopers: () => descoApi.get("/developers/index"),

  // Area APIs
  getAreas: () => descoApi.get("/areas/index"),

  // Featured Properties
  getFeaturedProperties: () => descoApi.get("/properties/featured"),

  // Contact APIs
  submitContact: (formData) => descoApi.post("/contact_us/index", formData),

  // custom selected offplan properties
  getLatestProperties: () => descoApi.get("/offplan_properties/index"),

  // Property APIs (Estaty)
  getProperties: (page = 1) =>
    estatyApi.post(`/getProperties?page=${page}`, {}),

  // Property Filter APIs (Desco)
  getBuyProperties: () => descoApi.get("/properties/buy"),
  filterBuyProperties: (formData) =>
    descoApi.post("/properties/buy_filter", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getRentProperties: () => descoApi.get("/properties/rent"),
  filterRentProperties: (formData) =>
    descoApi.post("/properties/rent_filter", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  // https://project.trogon.info/desco/api/seo/seo_key?slug=aboutus
  // WhatsApp
  getWhatsAppLink: (
    message = "Hello Desco Real Estate Team! I came across your website and would like to inquire about your properties or services."
  ) => {
    return `https://wa.me/971585903805?text=${encodeURIComponent(message)}`;
  },
};

export default apiService;
